import styles from "modules/site-structure/style-component.module.scss";
import SafeLink from "modules/components/SafeLink";

interface IProps {
  url: string;
  title: string;
}

function YearCards(props: IProps) {
  const { title, url } = props;
  return (
    <SafeLink href={url}>
      <div className={styles.style_model_item}>

        <a>

          <span>{title}</span>

          <i className="fa fa-chevron-right" aria-hidden="true" style={{ fontSize: "calc(1 * var(--safari-root-font, 10px))", color: "#616161" }} />
        </a>
      </div>
    </SafeLink>

  );
}

export default YearCards;
